// Normally we'd send a product interaction event ourselves when the user clicks on a product,
// however that requires us to fetch more context from Snowplow, which means we'd need to get
// in the way of the link. Instead, we add the necessary information to the URL and let the
// recipient fire the events on page load
export function getEffectiveUrl({ id, sourceId, sourceType, sourcePosition, offerId, url, }) {
    const existingParams = getParams(url);
    const required = {
        pid: id,
        sid: sourceId,
        st: sourceType,
        sp: sourcePosition,
        oid: offerId,
    };
    const extraParams = Object.keys(required)
        .filter((key) => existingParams[key] == null)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(required[key])}`)
        .join("&");
    return `${url}?${extraParams}`;
}
function getParams(url) {
    const queryParts = url
        .replace(/.*\?/, "")
        .split("&")
        .map((part) => part.split("="));
    return Object.fromEntries(queryParts);
}
